import { configureStore } from '@reduxjs/toolkit';
import heroReducer from './heroSlice';
import chatReducer from './chatSlice';
import newsReducer from './newsSlice'; // <-- Import the new reducer
import artworksReducer from './artworksSlice';

const store = configureStore({
  reducer: {
    hero: heroReducer,
    chat: chatReducer,
    news: newsReducer, // <-- This line was missing
    artworks: artworksReducer,
  },
});

export default store;
